module.exports = __webpack_public_path__ + "img/404.61499688.png";